import React from "react";
import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-button">← back to home</Link>
        
        <h1>Terms and Conditions</h1>
        <p className="company-name">Plaza Tech Software LLC</p>
        <p className="last-updated">Last updated: January 2026</p>

        <section>
          <h2>Agreement to Terms</h2>
          <p>
            These Terms and Conditions constitute a legally binding agreement between you and 
            Plaza Tech Software LLC ("Company", "we", "us", "our").
          </p>
          <p>
            By accessing or using any products, services, or websites operated by Plaza Tech Software LLC, 
            you agree to be bound by these Terms.
          </p>
          <p>If you do not agree, do not use our services.</p>
        </section>

        <section>
          <h2>Company Information</h2>
          <p>
            Plaza Tech Software LLC<br />
            131 Continental Dr, Suite 305<br />
            Newark, DE 19713<br />
            United States
          </p>
          <p className="contact-info">
            Contact: <a href="mailto:dan@plaza.tech">dan@plaza.tech</a>
          </p>
        </section>

        <section>
          <h2>Services</h2>
          <p>
            Plaza Tech Software LLC operates multiple digital products and services across various platforms 
            and domains, including web applications, mobile apps, developer tools, and AI technologies.
          </p>
          <ul>
            <li>Services are provided on a subscription and/or licensing basis.</li>
            <li>All products are delivered digitally.</li>
            <li>Each product may have additional specific terms.</li>
          </ul>
        </section>

        <section>
          <h2>Accounts</h2>
          <p>You are responsible for maintaining the confidentiality of your account credentials.</p>
          <p>You agree not to:</p>
          <ul>
            <li>Violate any applicable laws</li>
            <li>Reverse engineer or resell our software</li>
            <li>Abuse or attempt to exploit our systems</li>
          </ul>
        </section>

        <section>
          <h2>Payments</h2>
          <ul>
            <li>Payments are processed securely via Stripe.</li>
            <li>You authorize us to charge your payment method according to your selected plan.</li>
            <li>Prices may change at any time. Active subscriptions will retain pricing until renewal.</li>
          </ul>
        </section>

        <section>
          <h2>No Refund Policy</h2>
          <p>
            All purchases are final. Refunds are not provided except where required by law or in the 
            case of billing errors.
          </p>
        </section>

        <section>
          <h2>Intellectual Property</h2>
          <p>
            All software, content, trademarks, and materials are the exclusive property of 
            Plaza Tech Software LLC.
          </p>
          <p>You receive a limited, non-transferable license to use our software.</p>
        </section>

        <section>
          <h2>Termination</h2>
          <p>We reserve the right to suspend or terminate accounts that violate these Terms.</p>
        </section>

        <section>
          <h2>Disclaimer</h2>
          <p>Our services are provided "as is" and "as available" without warranties of any kind.</p>
          <p>We do not guarantee uninterrupted or error-free operation.</p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>
            Plaza Tech Software LLC shall not be liable for any indirect, incidental, special, or 
            consequential damages.
          </p>
          <p>Our total liability shall not exceed the amount paid by you in the previous 12 months.</p>
        </section>

        <section>
          <h2>Governing Law</h2>
          <p>These Terms are governed by the laws of the State of Delaware, United States.</p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            For legal inquiries:<br />
            📧 <a href="mailto:dan@plaza.tech">dan@plaza.tech</a>
          </p>
        </section>
      </div>
    </div>
  );
}


